import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class HomeBanner extends Component {
  static propTypes = {
    image: PropTypes.string.isRequired,
    t: PropTypes.func,
  };

  render() {
    return (
      <div className="home-banner">
        <img src={this.props.image} alt={this.props.t('TRANSLATIONS.BANNER_IMG')} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/HomeBanner.js